<template>
    <span>
        <button v-if="!hideButton" @click.prevent="showModal = true" :class="btnClasses" :disabled="isDisabled">
            <slot name="buttonTxt"></slot>
        </button>

        <modal :value="showModal" :showFooter="false">
            <template v-slot:header>
                <div class="modal-title">
                    <slot name="modalTitle"></slot>
                </div>
            </template>
            <template v-slot:content>
                <slot name="modalBody"></slot>
                <!-- isLoading -->
                <template v-if="isLoading">
                    <loader />
                </template>
                <!-- Error! -->
                <template v-else-if="isError">
                    <HasError :e="isError" />
                    <a href="javascript:void(0);" class="button is-cancel" @click.prevent="closeModal">{{
                        $t('close')
                    }}</a>
                </template>
                <template v-else>
                    <!-- the Form -->
                    <div class="mt15-xs">
                        <button :class="actionClasses" @click.prevent="doConfirm()">
                            {{ $t('yes') }}
                        </button>
                        <button class="button is-cancel" @click.prevent="closeModal()">
                            {{ $t('cancel') }}
                        </button>
                    </div>
                </template>
            </template>
        </modal>
    </span>
</template>

<script>
import modal from './modal.vue';
import useModal from './../composables/useModal.js';
import HasError from './HasError.vue';

/*
Use events to change it's state:
document.dispatchEvent(new Event(`${result.eventName}.isSuccess`));
document.dispatchEvent(new CustomEvent(`${result.eventName}.isError`, { detail: e }));
*/
export default {
    name: 'ButtonConfirm',
    components: {
        modal,
        HasError,
    },
    props: {
        onConfirm: {
            type: Function,
            required: true,
        },
        action: {
            type: String, //DELETE, CREATE, SUCCESS, WARNING
        },
        iniDisabled: {
            type: Boolean,
        },
        eventName: {
            type: String,
            required: true,
        },
        hideButton: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, context) {
        return useModal(props, context);
    },
    data() {
        return {
            isLoading: false,
            isSuccess: false,
            isError: false,

            showModal: false,
        };
    },
    computed: {
        btnClasses() {
            if (this.action == 'DELETE') {
                return 'button is-danger';
            } else if (this.action == 'CREATE') {
                return 'button is-success';
            } else if (this.action == 'SUCCESS') {
                return 'button is-success';
            } else if (this.action == 'WARNING') {
                return 'button is-warning';
            }
            return 'button is-cancel';
        },
        actionClasses() {
            if (this.action == 'DELETE') {
                return 'button is-danger';
            } else if (this.action == 'CREATE') {
                return 'button is-success';
            } else if (this.action == 'SUCCESS') {
                return 'button is-success';
            } else if (this.action == 'WARNING') {
                return 'button is-warning';
            }
            return 'button';
        },
        isDisabled() {
            return this.iniDisabled || this.isLoading;
        },
    },
    created: function () {
        document.addEventListener(`${this.eventName}.show`, this.onShow);
        document.addEventListener(`${this.eventName}.isSuccess`, this.onSuccess);
        document.addEventListener(`${this.eventName}.isError`, this.onError);
    },
    beforeDestroy() {
        this.closeModal();
        document.removeEventListener(`${this.eventName}.show`, this.onShow);
        document.removeEventListener(`${this.eventName}.isSuccess`, this.onSuccess);
        document.removeEventListener(`${this.eventName}.isError`, this.onError);
    },
    methods: {
        onShow() {
            //reset the states...
            this.isLoading = false;
            this.isSuccess = false;
            this.isError = false;
            this.showModal = true;
        },
        onSuccess(payload) {
            this.isLoading = false;
            this.isSuccess = true;
            this.isError = false;
            this.closeModal();
        },
        onError(e) {
            this.isLoading = false;
            this.isSuccess = false;
            this.isError = e ? e.detail : true;
        },
        closeModal() {
            this.showModal = false;
            //reset the states...
            this.isLoading = false;
            this.isSuccess = false;
            this.isError = false;
        },
        doConfirm() {
            this.isLoading = true;
            this.onConfirm({
                eventName: this.eventName,
                result: true,
            });
        },
    },
    i18n: {
        messages: {
            en: {
                close: 'Close',
                cancel: 'Cancel',
                yes: 'Yes',
            },
            fr: {
                close: 'Fermer',
                cancel: 'Annuler',
                yes: 'Oui',
            },
            nl: {
                close: 'Sluiten',
                cancel: 'Annuleren',
                yes: 'Ja',
            },
        },
    },
};
</script>
